/**
 * @generated SignedSource<<f6b57c09382683bd91dfaf75e95db40c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetNoteEditingMode = "DEFAULT" | "READ_ONLY";
import { FragmentRefs } from "relay-runtime";
export type widgetSettingsAvailable_widget$data = {
  readonly __typename: string;
  readonly editingMode?: WidgetNoteEditingMode;
  readonly id: string;
  readonly " $fragmentType": "widgetSettingsAvailable_widget";
};
export type widgetSettingsAvailable_widget$key = {
  readonly " $data"?: widgetSettingsAvailable_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"widgetSettingsAvailable_widget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "widgetSettingsAvailable_widget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "editingMode",
          "storageKey": null
        }
      ],
      "type": "WidgetNote",
      "abstractKey": null
    }
  ],
  "type": "Widget",
  "abstractKey": "__isWidget"
};

(node as any).hash = "a330883484816d90412757e3d792c32c";

export default node;
